import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BlobModelService } from "../services/blob-model/blob-model.service";

@Injectable()
export class BlobModelRepository {
	constructor(private service: BlobModelService) {}

	public createNewBlobModel(file?: File, callback?: Function): void {
		this.service.postBlobModel(file!, callback);
	}

	public getBlobModelByUrl(url: string, callback?: Function): void {
		this.service.getBlobModelByUrl(url, callback);
	}

	public getBlobModel$(blob_id: string): Observable<any> {
		return this.service.getBlobById$(blob_id);
	}
}
